import { Spinner } from "../ui/spinner";
import {
  PageLoadingSkeleton,
  TableLoadingSkeleton,
  CardLoadingSkeleton,
  FormLoadingSkeleton,
  ListLoadingSkeleton,
  ChatLoadingSkeleton
} from "../Feedback/Skeletons";

// Mapa de variantes de skeleton
const skeletonVariants = {
  page: PageLoadingSkeleton,
  table: TableLoadingSkeleton,
  card: CardLoadingSkeleton,
  form: FormLoadingSkeleton,
  list: ListLoadingSkeleton,
  chat: ChatLoadingSkeleton,
};

export const Loader = ({ 
  size, 
  style, 
  styleSVG, 
  variant = "default",
  legacy = false,
  ...skeletonProps 
}) => {
  // Usar Spinner se solicitado ou se variant for "default"
  if (legacy || variant === "default") {
    // Converter size numérico para string
    let spinnerSize = "md";
    if (size) {
      if (size <= 20) spinnerSize = "sm";
      else if (size <= 32) spinnerSize = "md";
      else if (size <= 48) spinnerSize = "lg";
      else spinnerSize = "xl";
    }

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...style,
        }}
      >
        <Spinner
          size={spinnerSize}
          className="border-t-[#539d65]"
          style={{ ...styleSVG }}
        />
      </div>
    );
  }

  // Usar skeleton baseado na variante
  const SkeletonComponent = skeletonVariants[variant];
  
  if (!SkeletonComponent) {
    console.warn(`Loader variant "${variant}" not found. Using default.`);

    // Converter size numérico para string
    let spinnerSize = "md";
    if (size) {
      if (size <= 20) spinnerSize = "sm";
      else if (size <= 32) spinnerSize = "md";
      else if (size <= 48) spinnerSize = "lg";
      else spinnerSize = "xl";
    }

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...style,
        }}
      >
        <Spinner
          size={spinnerSize}
          className="border-t-[#539d65]"
          style={{ ...styleSVG }}
        />
      </div>
    );
  }

  return <SkeletonComponent {...skeletonProps} />;
};
